<div class="vis-error-container">
  {{ 'error_messages.visualization_error_generic' | translate }}
</div>
